/* Pixeo Suite - servido por el CDN de Shopify. No editar a mano. */
(function () {
  'use strict';

  var config = window.PIXEO_SUITE_CONFIG || {};

  // En el editor de temas no se ejecuta nada: ni redirecciones ni notificaciones.
  if (config.designMode) return;

  var CITIES_BY_COUNTRY = {"CO":["Bogotá","Medellín","Cali","Barranquilla","Cartagena","Bucaramanga","Pereira","Santa Marta","Manizales","Cúcuta"],"MX":["Ciudad de México","Guadalajara","Monterrey","Puebla","Tijuana","León","Cancún","Mérida","Querétaro","San Luis Potosí"],"AR":["Buenos Aires","Córdoba","Rosario","Mendoza","La Plata","Mar del Plata","San Miguel de Tucumán","Salta","Santa Fe","Neuquén"],"CL":["Santiago","Valparaíso","Concepción","La Serena","Antofagasta","Temuco","Rancagua","Talca","Arica","Iquique"],"PE":["Lima","Arequipa","Trujillo","Chiclayo","Piura","Cusco","Iquitos","Huancayo","Tacna","Pucallpa"],"EC":["Quito","Guayaquil","Cuenca","Santo Domingo","Machala","Manta","Portoviejo","Ambato","Riobamba","Loja"],"VE":["Caracas","Maracaibo","Valencia","Barquisimeto","Maracay","Ciudad Guayana","Barcelona","Maturín","Puerto La Cruz","Mérida"],"ES":["Madrid","Barcelona","Valencia","Sevilla","Zaragoza","Málaga","Murcia","Palma","Bilbao","Alicante"],"US":["Miami","Los Angeles","Houston","New York","Chicago","San Antonio","Phoenix","San Diego","Dallas","San Jose"],"PA":["Ciudad de Panamá","San Miguelito","David","Colón","La Chorrera","Arraiján","Santiago","Chitré","Penonomé","Bocas del Toro"],"CR":["San José","Limón","Alajuela","Heredia","Cartago","Puntarenas","Liberia","Nicoya","San Isidro","Turrialba"],"GT":["Ciudad de Guatemala","Mixco","Villa Nueva","Quetzaltenango","Escuintla","Chinautla","Petapa","San Juan Sacatepéquez","Cobán","Huehuetenango"],"HN":["Tegucigalpa","San Pedro Sula","Choloma","La Ceiba","El Progreso","Choluteca","Comayagua","Puerto Cortés","Danlí","Siguatepeque"],"SV":["San Salvador","Santa Ana","San Miguel","Mejicanos","Santa Tecla","Apopa","Soyapango","Delgado","Ilopango","Cojutepeque"],"NI":["Managua","León","Masaya","Matagalpa","Chinandega","Estelí","Granada","Jinotega","Juigalpa","Bluefields"],"DO":["Santo Domingo","Santiago","San Pedro de Macorís","La Romana","San Cristóbal","Puerto Plata","San Francisco de Macorís","Higüey","La Vega","Moca"],"PR":["San Juan","Bayamón","Carolina","Ponce","Caguas","Guaynabo","Mayagüez","Trujillo Alto","Arecibo","Fajardo"],"BO":["La Paz","Santa Cruz","Cochabamba","Sucre","Oruro","Tarija","Potosí","Trinidad","Cobija","Riberalta"],"PY":["Asunción","Ciudad del Este","San Lorenzo","Luque","Capiatá","Lambaré","Fernando de la Mora","Limpio","Ñemby","Encarnación"],"UY":["Montevideo","Salto","Ciudad de la Costa","Paysandú","Las Piedras","Rivera","Maldonado","Tacuarembó","Melo","Mercedes"],"CU":["La Habana","Santiago de Cuba","Camagüey","Holguín","Santa Clara","Guantánamo","Bayamo","Las Tunas","Cienfuegos","Pinar del Río"],"BR":["São Paulo","Río de Janeiro","Brasília","Salvador","Fortaleza","Belo Horizonte","Manaus","Curitiba","Recife","Porto Alegre"]};

  // Si el ajuste del tema llegara vacío, se usan las ciudades del país por
  // defecto en lugar de nombres genéricos: un "Desde Norte" se ve roto y resta
  // credibilidad justo a la notificación que busca darla.
  var FALLBACK_COUNTRY = "CO";
  var NAMES = ["Juan","Ana","Luis","Carlos","María","Elena","David","Javier","Sofía","Ricardo","Laura","Pedro","Isabel","Miguel","Andrea","Pablo","Sara","Fernando","Lucía","Jorge","Carmen","Antonio","Rosa","Manuel","Patricia","José","Mónica","Francisco","Alejandra","Diego","Valentina","Sebastián","Camila","Andrés","Daniela","Roberto","Natalia","Eduardo","Paola","Cristian"];
  var BLOCKED_DOMAINS = ["ppspy.com","alihunter.io","productlistgenie.io","importyeti.com","spocket.co","oberlo.com","aliexpress.com/dropshipping","dsers.com","shopifyinspector.com","commerceinspector.com","koalainspector.com","shopifyspy.io","myip.ms/shopify","builtwith.com","shopistores.com","shopifycompass.com","nichescraper.com","ecomhunt.com","pexda.com","watchcount.com","bigspy.com","adspy.com","dropshiplooker.com","salesource.io","dropshipfinder.io","pingship.com","foxinsights.io","dropmock.com","pipiads.com","asify.co","dropispy.com","droppoint.site","dropship.io","findniche.com","thieve.co","dropshippiscanner.com","intelligynce.com","adplexity.com","keywordtool.io"];
  var EXTENSION_IDENTIFIERS = ["ppspy","alihunter","shopifyinspector","koalainspector","commerceinspector","nichescraper","ecomhunt","dropispy","dropship","spocket","oberlo","adspy","bigspy","importyeti","shopify-spy","product-scanner","ds-hunter","ali-orders","drop-spy","ecom-hunt","product-research","winning-product","shopalyst"];
  var SPY_REDIRECT_URL = "https://pixeodesign.co";
  var DEFAULT_NOTIFICATION_COLOR = '#E74C3C';

  function shuffle(items) {
    var result = items.slice();
    for (var i = result.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = result[i];
      result[i] = result[j];
      result[j] = swap;
    }
    return result;
  }

  function citiesForCountry(country) {
    var cities = CITIES_BY_COUNTRY[String(country || '').toUpperCase()] || CITIES_BY_COUNTRY[FALLBACK_COUNTRY];
    return shuffle(cities).slice(0, 8);
  }

  // --- Clic derecho y atajos de inspección -------------------------------
  function startRightClickBlock() {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
      try { window.location.href = SPY_REDIRECT_URL; } catch (err) {}
      return false;
    }, true);

    document.addEventListener('keydown', function (e) {
      var isDevToolsShortcut =
        e.keyCode === 123 ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C')) ||
        (e.ctrlKey && e.key === 'U');
      if (isDevToolsShortcut) e.preventDefault();
    });
  }

  // --- Bloqueo de DevTools ----------------------------------------------
  function startDevToolBlock() {
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/disable-devtool@0.3.9';
    script.setAttribute('disable-devtool-auto', '');
    document.head.appendChild(script);
  }

  // --- Anti-espionaje avanzado ------------------------------------------
  function isBlockedUrl(url) {
    var value = String(url);
    for (var i = 0; i < BLOCKED_DOMAINS.length; i++) {
      if (value.indexOf(BLOCKED_DOMAINS[i]) !== -1) return true;
    }
    return false;
  }

  function startAdvancedSpyBlock() {
    console.log('Pixeo: Módulo de protección anti-espionaje avanzado iniciado.');

    if (window.fetch) {
      var originalFetch = window.fetch;
      window.fetch = function (resource) {
        if (isBlockedUrl(resource)) {
          console.warn('Pixeo Anti-Spy: Solicitud fetch bloqueada a: ' + resource);
          return Promise.reject(new Error('Solicitud bloqueada'));
        }
        return originalFetch.apply(this, arguments);
      };
    }

    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isBlockedUrl(url)) {
        console.warn('Pixeo Anti-Spy: Solicitud XHR bloqueada a: ' + url);
        this.abort();
        return;
      }
      return originalOpen.apply(this, arguments);
    };

    var startedAt = Date.now();
    var scanner = setInterval(function () {
      if (Date.now() - startedAt > 120000) { clearInterval(scanner); return; }

      var detected = '';

      for (var i = 0; i < BLOCKED_DOMAINS.length && !detected; i++) {
        var domain = BLOCKED_DOMAINS[i];
        var domainSelector = 'a[href*="' + domain + '"],iframe[src*="' + domain + '"],script[src*="' + domain + '"],img[src*="' + domain + '"]';
        if (document.querySelectorAll(domainSelector).length > 0) detected = domain;
      }

      for (var j = 0; j < EXTENSION_IDENTIFIERS.length && !detected; j++) {
        var id = EXTENSION_IDENTIFIERS[j];
        var idSelector = '[id*="' + id + '"],[class*="' + id + '"],[data-extension*="' + id + '"],[name*="' + id + '"]';
        if (document.querySelectorAll(idSelector).length > 0) detected = id;
      }

      if (detected) {
        console.error('PIXEO ANTI-SPY: ¡AMENAZA DETECTADA! Herramienta de espionaje activa: ' + detected + '. Redirigiendo al visitante...');
        clearInterval(scanner);
        try { window.location.replace(SPY_REDIRECT_URL); } catch (e) { window.location.href = SPY_REDIRECT_URL; }
      }
    }, 1500);
  }

  // --- Notificaciones de venta ------------------------------------------
  function findProductImage() {
    var metaImage = document.querySelector('meta[property="og:image"]');
    if (metaImage && metaImage.content) return metaImage.content;

    var productImage = document.querySelector('.product-single__photo img, .product__media img, .product-image img, [class*="product"] img');
    if (productImage && productImage.src) return productImage.src;

    var images = document.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      if (image.naturalWidth > 200 && image.naturalHeight > 200 && image.src.indexOf('icon') === -1 && image.src.indexOf('logo') === -1) {
        return image.src;
      }
    }
    return null;
  }

  function findProductTitle() {
    var metaTitle = document.querySelector('meta[property="og:title"]');
    if (metaTitle && metaTitle.content) return metaTitle.content;

    var heading = document.querySelector('h1.product-single__title, h1.product__title, h1[class*="product"]');
    if (heading) return heading.textContent.trim();

    return 'este producto';
  }

  function startFakeSales(cities, color) {
    var notificationColor = (color || DEFAULT_NOTIFICATION_COLOR).replace('%23', '#');

    function showNotification() {
      var productImage = findProductImage();
      var productTitle = findProductTitle();
      var name = NAMES[Math.floor(Math.random() * NAMES.length)];
      var city = cities[Math.floor(Math.random() * cities.length)];
      var units = Math.floor(Math.random() * 2) + 1;

      var wrapper = document.createElement('div');
      wrapper.style.cssText = 'position:fixed;top:15px;right:15px;z-index:10000;display:flex;flex-direction:row;align-items:stretch;transition:all 0.5s ease-in-out;opacity:0;transform:translateX(100%);font-family:"Segoe UI",Roboto,Helvetica,Arial,sans-serif;border-radius:10px;overflow:hidden;box-shadow:0 4px 15px rgba(0,0,0,0.2);max-width:320px;background:#fff;';

      if (productImage) {
        var imageBox = document.createElement('div');
        imageBox.style.cssText = 'flex-shrink:0;width:80px;height:80px;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#f5f5f5;';
        var image = document.createElement('img');
        image.src = productImage;
        image.style.cssText = 'width:100%;height:100%;object-fit:cover;';
        image.onerror = function () { this.style.display = 'none'; };
        imageBox.appendChild(image);
        wrapper.appendChild(imageBox);
      }

      var textBox = document.createElement('div');
      textBox.style.cssText = 'flex:1;display:flex;flex-direction:column;justify-content:center;background:#fff;';

      var topPart = document.createElement('div');
      topPart.style.cssText = 'background-color:#fff;color:#333;padding:10px 12px 6px 12px;font-size:13px;line-height:1.3;';

      var bottomPart = document.createElement('div');
      bottomPart.style.cssText = 'background-color:' + notificationColor + ';color:#fff;padding:6px 12px;font-size:11px;font-weight:600;line-height:1.2;';

      if (productImage) {
        var shortTitle = productTitle.substring(0, 25) + (productTitle.length > 25 ? '...' : '');
        topPart.innerHTML =
          '<div style="font-size:13px;font-weight:600;color:#333;margin-bottom:3px;">' + name + '...</div>' +
          '<div style="font-size:12px;color:#555;">Compró <span style="font-weight:600;color:' + notificationColor + ';">' + shortTitle + '</span></div>';
        bottomPart.textContent = '📍 Desde ' + city + ', ahora mismo';
      } else {
        topPart.innerHTML =
          '<strong style="font-weight:bold;">' + name + '</strong> compró ' +
          '<strong style="color:' + notificationColor + ';">' + units + ' unidad' + (units > 1 ? 'es' : '') + '</strong>';
        bottomPart.textContent = '📍 Desde ' + city;
      }

      textBox.appendChild(topPart);
      textBox.appendChild(bottomPart);
      wrapper.appendChild(textBox);
      document.body.appendChild(wrapper);

      setTimeout(function () {
        wrapper.style.opacity = '1';
        wrapper.style.transform = 'translateX(0)';
      }, 100);

      setTimeout(function () {
        wrapper.style.opacity = '0';
        wrapper.style.transform = 'translateX(100%)';
        setTimeout(function () {
          if (document.body.contains(wrapper)) document.body.removeChild(wrapper);
        }, 500);
      }, 4500);
    }

    setTimeout(function () {
      showNotification();
      setInterval(showNotification, (Math.random() * 9 + 16) * 1000);
    }, 6000);
  }

  function start() {
    if (config.antiSpy) startRightClickBlock();
    if (config.devtoolBlock) startDevToolBlock();
    if (config.advancedSpyBlock) startAdvancedSpyBlock();
    if (config.fakeSales) startFakeSales(citiesForCountry(config.country), config.fakeSalesColor);
  }

  // El asset se carga con `defer`, así que el DOM ya está parseado. El guard
  // queda igual por si alguien lo inyecta de otra forma.
  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
